import React, {useState, useContext} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Text, View, Pressable } from 'react-native';
import { PADDLE_SERVICES_WITH_COUNT, HIDE_PADDLE_SERVICE } from './queries';
import { useMutation } from '@apollo/client';
// import SubNav from './SubNav';
import { Link } from 'app/src/utils/routing';
import { useParams } from 'react-router-dom';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   LinkSpace,
   SubNavContainer,
   TableNavbarContainer
} from '../../elements';
import Modal from '../../elements/Modal';
import NewPaddleService from './new';
import EditPaddleService from './edit';
import currencyFormatter from '../../utils/currencyFormatter';
import SubNav from '../../elements/SubNav';
import moment from 'moment';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from '../../elements/Pagination/ResetSettings';
import AuthContext from '../../contexts/AuthContext';

export const PADDLE_SERVICE_CODES = ['EF', 'NL', 'PB'];

const inputStyle = {
  marginBottom: '10px'
}

const PaddleServices = (props) => {
  const { hasPolicy } = useContext(AuthContext);
  const { assetId } = useParams();
  const { asset, nestedSubNav } = props;
  const [refetch, setRefetch] = useState();
  const [clickedPaddleService, setClickedPaddleService] = useState();
  const [showAddPaddleServiceModal, setShowAddPaddleServiceModal] = useState(false);
  const [showEditPaddleServiceModal, setShowEditPaddleServiceModal] = useState(false);
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const [hidePaddleService] = useMutation(
    HIDE_PADDLE_SERVICE, { onCompleted: refetch }
  )
  const onHide = (paddleService) => {
    if(window.confirm(`Hide ${paddleService.name}?`)) {
      hidePaddleService({ variables: { id: paddleService.id }});
    }
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });


  const columns = [
    {
      key: 'name',
      label: 'Name',
      sort: 'asc',
      value: (entry) => entry.value
    },
    {
      key: 'code',
      label: 'Code',
      value: (entry) => entry.value
    },
    {
      key: 'serviceFeePercent',
      label: 'Service Fee Percent',
      value: (entry) => entry.value
    },
    {
      key: 'additionalFeePercent',
      label: 'Additional Fee Percent',
      value: (entry) => entry.value
    },
    {
      key: 'buyFeePercent',
      label: 'Buy Fee Percent',
      value: (entry) => entry.value
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        return (
          <LinkContainer>
            <Pressable
              onPress={() => {
                setClickedPaddleService(entry.entry);
                setShowEditPaddleServiceModal(true)
              }}
              style={{marginLeft: '10px'}}
              key={`sale-paddleService-link-${entry.entry.id}`}
              name={`sale-paddleService-link-${entry.entry.id}`}
            >
              <Text>Edit</Text>
            </Pressable>
            <LinkSpace/>
            {hasPolicy({ type: 'PaddleService', action: 'hide' }) && (
              <Pressable
                onPress={() => onHide(entry.entry)}
              >
                <Text>Hide</Text>
              </Pressable>
            )}
          </LinkContainer>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View>
          <Text>Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.name || ''}
            style={inputStyle}
          />
        </View>
      </Filter>
      <ResetSettings />
    </View>
  )

  return (
    <MainContainer>
      {!nestedSubNav &&
        <SubNavContainer>
          <SubNav>
            {getSubNavContents()}
          </SubNav>
        </SubNavContainer>
      }
      <ContentContainer>
        <PageTitle>Paddle Services</PageTitle>
        <br /><br />
        <TableContainer>
          {nestedSubNav &&
            <TableNavbarContainer>
              <SubNav>
                {getSubNavContents()}
              </SubNav>
            </TableNavbarContainer>
          }
          <DataTable.Gql
            setRefetch={setRefetch}
            query={PADDLE_SERVICES_WITH_COUNT}
            queryName='paddleServicesWithCount'
            columns={columns}
            buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.paddleServicesWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {showEditPaddleServiceModal &&
        <Modal
          refetch={refetch}
          showModal={showEditPaddleServiceModal}
          setShowModal={setShowEditPaddleServiceModal}
          modalType={'Edit PaddleService'}
          objectName={clickedPaddleService.name}
        >
          <EditPaddleService
            setShowModal={setShowEditPaddleServiceModal}
            refetch={refetch}
            paddleService={clickedPaddleService}
            asset={asset}
          />
        </Modal>
      }
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <View>
        {getLinks()}
      </View>
    )
    function getLinks() {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddPaddleServiceModal(true)}
          >
            <Text>+ Add Paddle Service</Text>
          </Pressable>
          {showAddPaddleServiceModal &&
            <Modal
              showModal={showAddPaddleServiceModal}
              setShowModal={setShowAddPaddleServiceModal}
              modalType={asset ? `Add PaddleService - ${asset.name}` : 'Add PaddleService'}
            >
              <NewPaddleService
                setShowModal={setShowAddPaddleServiceModal}
                refetch={refetch}
                knownAssetId={assetId}
                paddleService={clickedPaddleService}
                setClickedPaddleService={setClickedPaddleService}
                setShowAddPaddleServiceModal={setShowAddPaddleServiceModal}
                setShowEditPaddleServiceModal={setShowEditPaddleServiceModal}
              />
            </Modal>
          }
        </View>
      )
    }
  }
}

export default PaddleServices;
